import { RULE_STATUS } from 'helpers/sf_constants';
import { capitalizeFirstLetter } from 'helpers/sf_utils';
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { Card, CardBody, Label } from 'reactstrap'

const StatsCard = (props) => {
  const color = props.label === RULE_STATUS.PASSED ? 'sfgreen' : props.label === RULE_STATUS.FAILED ? 'sfred' : '';
  return (
    <Card className="sfgraph-widget-card">
      <CardBody>
        <Label className='font-weight-semibold'>{props?.label ? capitalizeFirstLetter(props?.label) : ""}</Label>
        {
          props?.loading ?
            <Skeleton />
            :
            <h1 className={`font-weight-semibold ${color}`}>
              <span className="text-black">{props.aggr_data || '--'}</span>
              {props.percent_change ? <span className={color}>({props.percent_change} %)</span> : ''}
            </h1>
        }
      </CardBody>
    </Card>
  )
}

export default StatsCard